import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColorName = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m24 3 14.849 6.151L45 24l-6.151 14.849L24 45 9.151 38.849 3 24 9.151 9.151ZM14 15.5a1.5 1.5 0 0 1 1.5-1.5h9.257a3 3 0 0 1 2.122.879l7.242 7.242a3 3 0 0 1 0 4.243l-7.757 7.757a3 3 0 0 1-4.243 0L14.88 26.88A3 3 0 0 1 14 24.757zm5.5 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
		clipRule: "evenodd"
	})
});
export default SvgColorName;
